import { Role } from '@/types/auth'

export type ShowingOption = {
    label: string
    days: number | null // null = All
}

const MILEAGE_CLERK_OPTIONS: ShowingOption[] = [
    { label: 'All', days: null },
    { label: 'Last 7 Days', days: 7 },
    { label: 'Last 24 Days', days: 24 },
]

const PERFORMANCE_MANAGER_OPTIONS: ShowingOption[] = [
    { label: 'Last 48 Hours', days: 2 },
    { label: 'Last 7 Days', days: 7 },
    { label: 'Last 24 Days', days: 24 },
]

export const SHOWING_OPTIONS_BY_ROLE: Partial<Record<Role, ShowingOption[]>> = {
    [Role.MileageClerk]: MILEAGE_CLERK_OPTIONS,
    [Role.PerformanceManager]: PERFORMANCE_MANAGER_OPTIONS,
}

export const DEFAULT_SHOWING_OPTION_BY_ROLE: Partial<Record<Role, ShowingOption>> = {
    [Role.MileageClerk]: MILEAGE_CLERK_OPTIONS[2],
    [Role.PerformanceManager]: PERFORMANCE_MANAGER_OPTIONS[1],
}

export const DEFAULT_SHOWING_OPTION = MILEAGE_CLERK_OPTIONS[0]
